import * as yup from "yup";

export const regexNameWithNumbers =
  // eslint-disable-next-line
  /^[a-zA-Z0-9áéíóúñZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-/\\. ]+$/i;

export const addressSchema = ({
  address1,
  address2,
  locality,
  postalCode,
}: {
  address1: string;
  address2: string;
  locality: string;
  postalCode: string;
}) => {
  return {
    [address1]: yup
      .string()
      .required("Required")
      .matches(regexNameWithNumbers, "Please enter valid Address")
      .max(110, "Address is too long (max 110 characters)"),
    [address2]: yup
      .string()
      .matches(regexNameWithNumbers, "Please enter valid Address")
      .max(110, "Is too long (max 110 characters)")
      .notRequired(),
    [locality]: yup
      .string()
      .required("Required")
      .matches(regexNameWithNumbers, "Please enter valid City")
      .max(40, "Locality is too long (max 40 characters)"),
    [postalCode]: yup
      .string()
      .required("Required")
      .matches(regexNameWithNumbers, "Please enter valid Postal Code")
      .max(20, "Postal Code is too long (max 20 characters)"),
  };
};

export const fullNameSchema = ({
  name,
  businessName,
}: {
  name: string;
  businessName: string;
}) => ({
  [name]: yup
    .string()
    .required("Required")
    .max(70, "Name is too long (max 70 characters)"),
  [businessName]: yup
    .string()
    .notRequired()
    .min(1, "Business name is too short"),
});

export const nameSchema = ({ name }: { name: string }) => ({
  [name]: yup.string().required("Required"),
});

export const birthDaySchema = ({ birthDay }: { birthDay: string }) => ({
  [birthDay]: yup.string().required("Required"),
});

export const RegionSchema = ({ region }: { region: string }) => ({
  [region]: yup
    .string()
    .max(22, "Region is too long (max 22 characters)"),
});

export const requiredSchema = ({ required }: { required: string }) => ({
  [required]: yup.string().required("Required"),
});

export const requiredCitizenSchema = ({ required }: { required: string }) => ({
  [required]: yup
    .string()
    .required("Required")
    .notOneOf(["US"], "Must not be United States"),
});

export const nameConfirmationSchema = ({
  nameConfirmation,
  agree,
}: {
  nameConfirmation: string;
  agree: string;
}) => ({
  [nameConfirmation]: yup
    .string()
    .test("match-name", "Name does not match", function (value) {
      // eslint-disable-next-line
      const formInvestorName = this.resolve(
        yup.ref("formInvestorName"),
      ) as string;
      return value?.toLowerCase() === formInvestorName?.toLowerCase();
    })
    .required("Required"),
  [agree]: yup.boolean().oneOf([true], "Required").required("Required"),
});

export const claimOfTaxSchema = ({ taxCountry }: { taxCountry: string }) => ({
  [taxCountry]: yup.string(),
});

export const taxPayerSchema = ({
  classification,
  identifier,
  exemptPayeeCodes,
  exemptFATCAReportingCodes,
  taxPayerIdNumber,
}: {
  classification: string;
  identifier: string;
  exemptPayeeCodes: string;
  exemptFATCAReportingCodes: string;
  taxPayerIdNumber: string;
}) => {
  return {
    [classification]: yup.string().required("Required"),
    [identifier]: yup.string().required("Required"),
    [taxPayerIdNumber]: yup
      .string()
      .matches(/\d/, "must contain numbers")
      .required("Required"),
    [exemptPayeeCodes]: yup.number().notRequired(),
    [exemptFATCAReportingCodes]: yup.string().notRequired(),
  };
};

export const w8TaxPayerSchema = ({
  USTaxPayerId,
  foreignTaxPayerId,
}: {
  USTaxPayerId: string;
  foreignTaxPayerId: string;
}) => {
  const errorMessage = "Required";
  const hasContent = (value: unknown): boolean => {
    return typeof value === "string" && value.trim().length > 0;
  };
  return {
    [USTaxPayerId]: yup
      .string()
      .matches(regexNameWithNumbers, "Please enter valid Tax Number")
      .matches(/\d/, "must contain numbers")
      .max(23, "max 23 characters")
      .test("at-least-one-tax-id-us", errorMessage, function (value) {
        const foreignRef = yup.ref(foreignTaxPayerId);
        const foreignValue = this.resolve(foreignRef);
        return hasContent(value) || hasContent(foreignValue);
      }),

    [foreignTaxPayerId]: yup
      .string()
      .matches(regexNameWithNumbers, "Please enter valid Tax Number")
      .max(23, "max 23 characters")
      .test("at-least-one-tax-id-foreign", errorMessage, function (value) {
        const usRef = yup.ref(USTaxPayerId);
        const usValue = this.resolve(usRef);
        return hasContent(value) || hasContent(usValue);
      }),
  };
};
